<app-dialog [header]="'Dispensing'" [show]="show">
  <form [formGroup]="dialogForm"
        (ngSubmit)="sendTransaction()"
        class="drug-form-container dispense-dialog-container"
  >
    <app-input-search-scanner formControlName="friendlyName"
                              [autofocus]="show"
                              [isInventory]="true"
                              (optionSelected)="optionSelected($event)"
                              (searchValueChanged)="handleSearchInput($event)"
                              (keydownTab)="dialogForm.get('friendlyName').value ? focusInput('rxNumberInput') : focusButton('closeButton')"
                              [placeholder]="'Scan barcode (Or search drug name or NDC)'"
                              [label]="'Which drug are you dispensing?'"
                              [errorMessage]="'No inventory exists'"
                              [active]="true"
                              [searchEmptyInventory]="false"
                              #searchScanner
                              *ngIf="!drug"
    ></app-input-search-scanner>

    <app-selected-ndc-input *ngIf="drug"
      [drug]="drug"
      label="Drug you are dispensing"
    ></app-selected-ndc-input>

    <div [hidden]="dialogForm.get('drugId')?.invalid && !drug">
      <div class="form-row two-items">
        <app-input class="custom-input"
                   [label]="'Rx Number'"
                   (keyupEnter)="focusInput('patientNameInput')"
                   (keydownTab)="focusInput('patientNameInput')"
                   formControlName="rxNumber"
                   #rxNumberInput
        ></app-input>
        <app-input class="custom-input"
                   [label]="'Patient Name'"
                   (keyupEnter)="focusInput('addedQuantityInput')"
                   (keydownTab)="focusInput('addedQuantityInput')"
                   formControlName="patientName"
                   #patientNameInput
        ></app-input>
      </div>

      <div class="inventory-count-container">
        <div class="inventory-count-header">
          Inventory
        </div>

        <div class="inventory-items">
          <div class="inventory-item starting">
            <div class="label">Starting</div>
            <div class="value">{{(currentOption?.onHand | number) || 0}}</div>
          </div>
          <div class="inventory-item count">
            <div class="label">Dispense Count</div>
            <div class="value">
              <app-input [showErrors]="false"
                         [textAlign]="'right'"
                         formControlName="addedQuantity"
                         type="number"
                         [naturalNumbersOnly]="true"
                         (keyupEnter)="sendTransaction()"
                         (keydownTab)="dialogForm.invalid ? focusInput('rxNumberInput') : focusButton('submitButton')"
                         [disable]="!currentOption?.onHand"
                         #addedQuantityInput
              ></app-input>
            </div>
          </div>
          <div class="inventory-item on-hand">
            <div class="label">On-Hand</div>
            <div class="value">{{((currentOption?.onHand - +dialogForm.get('addedQuantity')?.value) | number) || 0}}</div>
          </div>
        </div>
        <div>
          <ng-content></ng-content>
        </div>
      </div>
    </div>

    <div class="dialog-controls-default">
      <app-button customClasses="px-4"
                  text="Cancel"
                  [minWidth]="0"
                  subStyle="transparent"
                  class="cancel-btn"
                  (clicked)="close()"
                  (keydownTab)="focusButton(dialogForm.invalid ? 'closeButton' : 'submitButton')"
                  #closeButton
      >
      </app-button>

      <app-button customClasses="px-4"
                  text="Dispense"
                  class="save-btn"
                  [disabled]="dialogForm.invalid"
                  (keydownTab)="focusInput('rxNumberInput')"
                  type="submit"
                  #submitButton
      >
      </app-button>
    </div>

  </form>
</app-dialog>
